import { cloneDeep } from 'lodash';
import validator from 'validator';

export const isDev = () => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
}

export const stringToHash = (value) => {
    var hash = 0, i, chr;
    if (value.length === 0) return hash;
    for (i = 0; i < value.length; i++) {
        chr = value.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export const addArrayItem = (array, newItem) => {
    const newArray = cloneDeep(array ? array : []).concat([newItem]);
    return newArray;
}

export const updateArrayItem = (array, updatedItem, selector) => {
    const newArray = cloneDeep(array ? array : []);
    if (newArray && newArray.length > 0) {
        const index = newArray.findIndex(selector);
        if (index !== -1)
            newArray[index] = updatedItem;
    }
    return newArray;
}

export const removeArrayItem = (array, selector) => {
    const newArray = cloneDeep(array ? array : []).filter((x) => !selector(x));
    return newArray;
}

export const removeObjectArrayItem = (obj, getter, selector) => {
    const newObj = cloneDeep(obj);
    const newArray = (getter(newObj) || []);
    const index = newArray.findIndex((x) => selector(x));
    if (index !== -1)
        newArray.splice(index, 1);
    return newObj;
}

export const addBundleItem = (bundle, newItem) => {
    const newBundle = cloneDeep(bundle);
    newBundle.items = (newBundle.items ? newBundle.items : []).concat([newItem]);
    return newBundle;
}

export const updateBundleItem = (bundle, updatedItem, selector) => {
    const newBundle = cloneDeep(bundle);
    if (newBundle.items && newBundle.items.length > 0) {
        const index = newBundle.items.findIndex(selector);
        if (index !== -1)
            newBundle.items[index] = updatedItem;
    }
    return newBundle;
}

export const removeBundleItem = (bundle, selector) => {
    const newBundle = cloneDeep(bundle);
    if (newBundle.items && newBundle.items.length > 0) {
        newBundle.items = newBundle.items.filter((x) => !selector(x));
    }
    return newBundle;
}

export const validateSchema = (schema, object, parentName = "") => {
    const errors = []
    Object.keys(schema).forEach(key => {
        if (typeof schema[key] == "object") {
            errors.push(...validateSchema(schema[key], object[key], `${parentName}.${key}`));
        } else {
            errors.push(validate(schema[key].split(" ").join("").split(",").reverse(), object[key], `${parentName}.${key}`));
        }
    })
    return errors;
}

export const validate = (validatorsFuncName, value, name = "") => {
    let error = {};
    validatorsFuncName.forEach(funcName => {
        if (funcName === "required") {
            if (value === null || value === undefined || value.length <= 0) {
                error.errorId = name;
                error.message = funcName;
            }
        } else {
            if (!validator[funcName](value.toString())) {
                error.errorId = name;
                error.message = funcName;
            }
        }
    })
    return error;
}

export const getColoredBottonStyle = (theme, color, v) => {
    return {
        color: theme.palette.getContrastText(color[v ?? 500]),
        backgroundColor: color[v ?? 500],
        '&:hover': {
            backgroundColor: color[v ? v + 200 : 700],
        }
    }
}